import * as React from "react";
import { Button, Col, Row, Form, FormGroup, Collapse, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { UserSearchSelect } from "../../components/ui/UserSearchSelect";
import { verifyAvidAccess } from '../ActionAlertFormContainer/lib/http';
import { getUsers } from "../MyAlertsContainer/lib/http";
import { userData } from '../../util/userData';
import { HttpRequest } from '../../util/http';
import { DataGrid } from "../../components/ui/DataGrid";

interface Tab {
  value: string
  label: string
  isActive: boolean
}
interface containerProps {
  activeTab?: string
}
interface containerState {
  activeTab: string
  tabs: Tab[]
  defaultUserID: number
  defaultUserIDBankwide: number
  currentAvid?: Avid
  bankWideAvid?: Avid
  childAvids?: Avid[]
  trail: trailNode[]
  users: User[]
  domains: Domain[]
  isPopUpAssigneeOpen: boolean
  isPopUpDeleteDomainOpen: boolean
  selectedAvidDefaultUser: number
  selectedAvid: Avid
  selectedDomain: Domain
  inputCurrentAvidUser: number
  inputSelectedAvidUser: number
  inputDomain: string
  inputRootCause: string
  inputRootCauseSelect: number
  inputEndState: string
  inputEndStateSelect: number
  rootCauseColumn?: TrackingColumn
  endStateColumn?: TrackingColumn
  permissionTypes: Permission[]
  actionAlertPermissions: Permission[]
  inputDomainValidation: boolean
  inputDomainWarningText: string
  userAssigmentConfirmationModalOpen: boolean
  userPermissionModalOpen: boolean
  selectedUserIdInput: number
  isSavingAssignee: boolean
  severityDefault: SeverityDefault[]
}
interface Avid {
  id: number
  label: string
  prevLink: string
  nextLink: string
  hierarchyLevel: string
  defaultUser: number
  customer: string
  childCount: number
  childAvids?: Avid[]
  defaultAssignee: number
  defaultAssigneeRecordID?: number
}

interface trailNode {
  label: string
  avid: Avid
}

interface User {
  id: number
  email: string
  username: string
}

interface Domain {
  id: number
  customer_id: number
  domain: string
  isDeleted: boolean
  createdBy: number
  createdDate: string
  updatedBy: number
  updatedDate: string
}

interface TrackingColumn {
  name: string
  isEnable: boolean
  isRequired: boolean
  isPopUpOpen: boolean
  optionList: TrackingOption[]
  inputWarning: string
  selectedItemID: number
  selectedItemLabel: string
}

interface TrackingOption {
  id: number
  label: string
  createdBy: number
  updatedBy: number
  createdDate: string
  updatedDate: string
}

interface Permission {
  id?: number
  permission_key: number
  permission_name: string
  permission_type: string
  description: string
  principal?: string
  type?: string
  resource?: string
  context?: string
  content: string
}

interface SeverityDefault {
  reason_id: number
  reason: string
  severity_id: number
  last_updated_by: number
}




export class ActionAlertsAdminContainer extends React.Component<containerProps, containerState> {
  state: containerState = {
    activeTab: 'userAssignment',
    tabs: [
      { value: 'userAssignment', label: 'User Assignment', isActive: true },
      { value: 'whitelist', label: 'Whitelist', isActive: false },
      { value: 'tracking', label: 'Tracking', isActive: false },
      { value: 'severity', label: 'Severity Default', isActive: false }
    ],
    defaultUserID: undefined,
    defaultUserIDBankwide: undefined,
    selectedAvidDefaultUser: undefined,
    selectedAvid: {
      id: undefined,
      label: 'ALL',
      prevLink: '',
      nextLink: 'Bankwide_0',
      defaultUser: undefined,
      hierarchyLevel: 'Bankwide',
      customer: '',
      childCount: 1,
      defaultAssignee: undefined
    },
    currentAvid: {
      id: undefined,
      label: 'ALL',
      prevLink: '',
      nextLink: 'Bankwide_0',
      defaultUser: undefined,
      hierarchyLevel: 'Bankwide',
      customer: '',
      childCount: 1,
      defaultAssignee: undefined
    },
    bankWideAvid: {
      id: undefined,
      label: 'ALL',
      prevLink: '',
      nextLink: 'Bankwide_0',
      defaultUser: undefined,
      hierarchyLevel: 'Bankwide',
      customer: '',
      childCount: 1,
      defaultAssignee: undefined
    },
    trail: [],
    childAvids: [],
    users: [],
    domains: [],
    permissionTypes: [],
    actionAlertPermissions: [],
    rootCauseColumn: {
      name: 'rootCauseColumn',
      isEnable: false,
      isRequired: false,
      isPopUpOpen: false,
      optionList: [],
      inputWarning: '',
      selectedItemID: undefined,
      selectedItemLabel: ''
    },
    endStateColumn: {
      name: 'endStateColumn',
      isEnable: false,
      isRequired: false,
      isPopUpOpen: false,
      optionList: [],
      inputWarning: '',
      selectedItemID: undefined,
      selectedItemLabel: ''
    },
    inputCurrentAvidUser: undefined,
    inputSelectedAvidUser: undefined,
    inputDomain: '',
    inputRootCause: '',
    inputRootCauseSelect: undefined,
    inputEndState: '',
    inputEndStateSelect: undefined,
    isPopUpAssigneeOpen: false,
    isPopUpDeleteDomainOpen: false,
    inputDomainValidation: true,
    inputDomainWarningText: '',
    selectedDomain: undefined,
    userAssigmentConfirmationModalOpen: false,
    userPermissionModalOpen: false,
    selectedUserIdInput: undefined,
    isSavingAssignee: false,
    severityDefault: []
  }

  constructor(props) {
    super(props);

    // Load users first, then load AVIDs (which depend on users being loaded)
    getUsers(userData.getCurrentProject()).then((users) => {
      this.setState({ users: users }, () => {
        // Only load AVID data after users are loaded to avoid race condition
        this.getBankwideAvid();
        this.getAvids('Bankwide_0');
      });
    });

    // These can load in parallel since they don't depend on users
    this.getDomains();
    this.getRootCauseList();
    this.getEndStateList();
    this.getPermissionsTypes();
    this.getActionAlertPermissions();

    this.handleInputChange = this.handleInputChange.bind(this);
  }


  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let partialState = {};
    partialState[name] = value;

    this.setState(partialState)
  }
  getBankwideAvid() {
    const project = userData.getCurrentProject();
    let data = { current_project: project };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_bankwide_avid', { data, method })
      .then((res: Avid) => {
        const userIndex = this.state.users.findIndex((user) => user.id == res.defaultAssignee)
        if (userIndex < 0) {
          res.defaultAssignee = undefined
        }
        this.setState({
          currentAvid: res,
          bankWideAvid: res,
          defaultUserID: (userIndex >= 0 ? res.defaultAssignee : undefined),
          defaultUserIDBankwide: (userIndex >= 0 ? res.defaultAssignee : undefined),
          selectedAvid: res,
          inputCurrentAvidUser: (userIndex >= 0 ? res.defaultAssignee : undefined),
          inputSelectedAvidUser: (userIndex >= 0 ? res.defaultAssignee : undefined)
        });
        let trail = []
        trail.push({
          label: 'ALL',
          avid: res
        });
        this.setState({ trail: trail });
      });
  }
  getAvids(parentId: string) {
    const project = userData.getCurrentProject();
    let data = { current_project: project, parentId: parentId };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_avids', { data, method })
      .then((res: Avid[]) => {
        let avids = [];
        res.forEach((avid) => {
          avids.push(avid);
        });
        this.setState({ childAvids: avids });
      });
  }

  getDomains() {
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/get_domains', { data, method })
      .then((res: any) => {
        if (res) {
          let domains = [];
          res.forEach((user) => {
            domains.push(user);
          });
          this.setState({ domains: domains });
        }
      });
  }

  getRootCauseList() {
    let { rootCauseColumn } = this.state;
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/rootcause/get_all', { data, method })
      .then((res: TrackingOption[]) => {
        if (res) {
          let options = [];
          res.forEach((option) => {
            options.push(option);
          });
          rootCauseColumn.optionList = options;
          this.setState({ rootCauseColumn: rootCauseColumn });
        }
      })
      .catch((res: Error) => {
        console.log(res);
      })
  }

  getEndStateList() {
    let { endStateColumn } = this.state;
    const data = { current_project: userData.getCurrentProject() };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/endstate/get_all', { data, method })
      .then((res: TrackingOption[]) => {
        if (res) {
          let options = [];
          res.forEach((option) => {
            options.push(option);
          });
          endStateColumn.optionList = options;
          this.setState({ endStateColumn: endStateColumn });
        }
      })
      .catch((res: Error) => {
        console.log(res);
      })
  }

  getActionAlertPermissions() {
    let { endStateColumn, rootCauseColumn } = this.state;
    const data = { resource: userData.getCurrentProject(), permission_type: 'ACTIONALERTS' };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/permission/get', { data, method })
      .then((res: Permission[]) => {
        let actionAlertPermissions = [];
        res.forEach((permission) => {
          actionAlertPermissions.push(permission);
          if (permission.permission_name == 'Enable Root Cause' && permission.principal == data.resource) {
            rootCauseColumn.isEnable = true;
          }
          if (permission.permission_name == 'Enable End State' && permission.principal == data.resource) {
            endStateColumn.isEnable = true;
          }
          if (permission.permission_name == 'Require Root Cause' && permission.principal == data.resource) {
            rootCauseColumn.isRequired = true;
          }
          if (permission.permission_name == 'Require End State' && permission.principal == data.resource) {
            endStateColumn.isRequired = true;
          }
        });
        this.setState({ rootCauseColumn: rootCauseColumn, endStateColumn: endStateColumn, actionAlertPermissions: actionAlertPermissions });
      })
      .catch((res: Error) => {
        console.log(res);
      })
  }

  getPermissionsTypes() {
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/permission/get', { method })
      .then((res: Permission[]) => {
        let permissionTypes = []
        res.forEach((permission) => {
          permissionTypes.push(permission);
        });
        this.setState({ permissionTypes: permissionTypes });
      })
      .catch((res: Error) => {
        console.log(res);
      })
  }

  updateTabs(activeTab: string) {
    let tabs = this.state.tabs;
    tabs.map((tab) => {
      tab.isActive = (tab.value == activeTab);
      return tab;
    });
    this.setState({
      tabs: tabs,
      activeTab: activeTab,
      inputDomain: ''
    });
  }

  updateDefaultUser(userID: number, currentAvid: Avid, prevUserID: number | undefined) {
    this.setState({ defaultUserID: userID, isSavingAssignee: true }, () => {
      this.saveAssignee(userID, prevUserID, currentAvid);
    });
  }

  updateDefaultUserBankwide(userID: number, currentAvid: Avid, prevUserID: number | undefined) {
    this.setState({ defaultUserID: userID, isSavingAssignee: true }, () => {
      this.saveAssigneeBankwide(userID, prevUserID, currentAvid);
    });
  }

  updateCurrentAvid(node: trailNode) {
    const { trail } = this.state;
    this.getAvids(node.avid.nextLink);
    this.setState({ currentAvid: node.avid, selectedAvid: node.avid, inputSelectedAvidUser: node.avid.defaultAssignee });
    // this.updateDrillDownPath(node, trail.findIndex((trailNode) => trailNode.avid.label == node.label));
    this.updateDrillDownPath(node, trail.indexOf(node));
  }
  updateDrillDownPath(node: trailNode, drillDown: number) {
    let { trail } = this.state;
    let updatedTrail = [];
    const label = node.label;
    const avid = node.avid;
    let defaultUserId = this.state.defaultUserID;
    if (drillDown == -1) {
      // add trail node to trail
      trail.push({ label: label, avid: avid });
      if (avid.defaultAssignee) {
        defaultUserId = avid.defaultAssignee;
      }
    }
    if (drillDown >= 0) {
      // remove child trail nodes
      updatedTrail = trail.slice(0, drillDown + 1);
      trail = updatedTrail;
      if (avid.defaultAssignee) {
        defaultUserId = avid.defaultAssignee;
      }
    }

    this.setState({ trail: trail, defaultUserID: defaultUserId });
  }

  updateCheckboxField(columnArg: TrackingColumn, fieldName: string, isEnable: boolean) {
    let updatedColumn: TrackingColumn = Object.assign({}, columnArg);
    if (isEnable) {
      const { permissionTypes, actionAlertPermissions } = this.state;

      let partialState = {};
      let path = '';
      const method = 'POST';
      let permission_name = '';

      permission_name = (fieldName == 'isEnable' ? 'Enable' : 'Require');
      permission_name = permission_name.concat(updatedColumn.name == 'rootCauseColumn' ? ' Root Cause' : ' End State');


      updatedColumn[fieldName] = !updatedColumn[fieldName];
      let data = {}
      let updatedActionAlertPermissions = [];
      let newPermission: Permission = undefined;
      userData.getUserId().then((userID) => {
        if (updatedColumn[fieldName]) {
          // create
          let permissionObj = permissionTypes.find((permissionType) => permissionType.permission_name == permission_name);
          updatedActionAlertPermissions = actionAlertPermissions;
          newPermission = Object.assign({}, permissionObj);
          data = {
            resource: userData.getCurrentProject(),
            principal: userData.getCurrentProject(),
            permission_key: permissionObj.permission_key,
            user_id: userID,
            permission_name: permission_name
          };
          path = 'create';
        } else {
          // delete
          // Make sure to delete any redundant permission object from DB
          let removedActionAlertPermissions = [];
          actionAlertPermissions.forEach((permission) => {
            if (permission.permission_name == permission_name) {
              removedActionAlertPermissions.push(permission.id);
            } else updatedActionAlertPermissions.push(permission);
          });
          data = { ids: JSON.stringify(removedActionAlertPermissions), permission_name: permission_name, user_id: userID };
          path = 'delete';
        }
        HttpRequest.fetch(`scripts/admin_action_alerts/permission/${path}`, { data, method })
          .then((res: any) => {
            if (res.id) {
              if (path == 'create') {
                newPermission.id = res.id;
                updatedActionAlertPermissions.push(newPermission);
              }
              partialState[updatedColumn.name] = updatedColumn;
              this.setState(partialState);
              this.setState({ actionAlertPermissions: updatedActionAlertPermissions });
            }
          });
      })
    }
  }

  saveAssignee(nextUserID: number, prevUserID: number, avid: Avid) {
    verifyAvidAccess(nextUserID, avid.nextLink).then((hasAccess) => {
      if (hasAccess) {
        const project = userData.getCurrentProject();
        let data = {
          current_project: project,
          avid_id: avid.id,
          user_id: nextUserID,
          record_id: avid.defaultAssigneeRecordID,
          avid_label: avid.label,
          prev_assignee: (prevUserID ? this.state.users[this.state.users.findIndex((user) => user.id == prevUserID)].username : 'NULL'),
          next_assignee: this.state.users[this.state.users.findIndex((user) => user.id == nextUserID)].username
        };
        const method = 'POST';
        HttpRequest.fetch('scripts/admin_action_alerts/update_default_assignee', { data, method })
          .then((res: any) => {
            if (res.success) {
              if (this.state.isPopUpAssigneeOpen) {
                this.setState({ isPopUpAssigneeOpen: false });
                this.getAvids(avid.prevLink);
              } else {
                let { currentAvid } = this.state;
                currentAvid.defaultAssignee = nextUserID;
                this.setState({ currentAvid: currentAvid });
              }
            }
            this.setState({ isSavingAssignee: false });
          });
      } else {
        this.setState({ userPermissionModalOpen: true })
      }
    })


  }

  saveAssigneeBankwide(nextUserID: number, prevUserID: number, avid: Avid) {
    const project = userData.getCurrentProject();
    let data = {
      current_project: project,
      avid_id: avid.id,
      avid: avid.nextLink,
      user_id: nextUserID,
      record_id: avid.defaultAssigneeRecordID,
      prev_assignee_id: avid.defaultAssignee,
      avid_label: avid.label,
      prev_assignee: (prevUserID ? this.state.users[this.state.users.findIndex((user) => user.id == prevUserID)].username : 'NULL'),
      next_assignee: this.state.users[this.state.users.findIndex((user) => user.id == nextUserID)].username
    };
    const method = 'POST';
    HttpRequest.fetch('scripts/admin_action_alerts/update_default_assignee_bankwide', { data, method })
      .then((res: any) => {
        if (res.success) {
          if (this.state.isPopUpAssigneeOpen) {
            this.setState({ isPopUpAssigneeOpen: false });
            this.getAvids(avid.prevLink);
          } else {
            let { currentAvid } = this.state;
            currentAvid.defaultAssignee = nextUserID;
            this.setState({ currentAvid: currentAvid });
          }
          this.getAvids('Bankwide_0');
        }
        this.setState({ isSavingAssignee: false });
      });
  }


  deleteDomain(domainId: number) {
    const domain = this.state.domains.find((domain) => domain.id == domainId);
    userData.getUserId().then((id) => {
      const data = { updatedBy: id, id: domainId, domain: domain.domain }
      const method = 'POST';
      HttpRequest.fetch('scripts/admin_action_alerts/delete_domain', { data, method })
        .then((res: any) => {
          if (res.success) {
            let { domains } = this.state;
            let updatedDomains = domains.filter((domain) => domain.id != domainId);
            this.setState({ domains: updatedDomains, isPopUpDeleteDomainOpen: false });
          }
        });
    });
  }

  addDomain() {
    let domainName = this.state.inputDomain;
    if (this.isValidDomainName(domainName)) {
      userData.getUserId().then((userId) => {
        const data = { domain: domainName, createdBy: userId, updatedBy: userId, current_project: userData.getCurrentProject() }
        const method = 'POST';
        HttpRequest.fetch('scripts/admin_action_alerts/create_domain', { data, method })
          .then((res: any) => {
            if (res.success) {
              this.getDomains();
              this.setState({ inputDomain: '', inputDomainValidation: true, inputDomainWarningText: '' });
            }
          });
      });
    } else {
      this.setState({ inputDomainValidation: false, inputDomainWarningText: 'Not a valid domain' })
    }
  }

  deleteOption(column: TrackingColumn) {
    let partialState = {}
    const path = column.name.toLowerCase().slice(0, column.name.indexOf('Column'));
    userData.getUserId().then((id) => {
      const data = { updatedBy: id, id: column.selectedItemID }
      const method = 'POST';
      HttpRequest.fetch(`scripts/admin_action_alerts/${path}/delete`, { data, method })
        .then((res: any) => {
          if (res.message == 'Root Cause was deleted' || res.message == 'End State was deleted') {
            let updatedList = column.optionList.filter((item) => item.id != column.selectedItemID);
            column.optionList = updatedList;
            column.isPopUpOpen = false;
            column.selectedItemID = undefined;
            column.selectedItemLabel = '';
            partialState[column.name] = column;
            this.setState(partialState);
          }
        });
    });
  }

  addOption(column: TrackingColumn) {
    let partialState = {}
    const path = column.name.toLowerCase().slice(0, column.name.indexOf('Column'));
    const currenProject = userData.getCurrentProject();
    // get user input based on column name
    const inputName = 'input' + column.name.charAt(0).toUpperCase() + column.name.slice(1, column.name.indexOf('Column'));
    const userInput = this.state[inputName];
    userData.getUserId().then((userId) => {
      const data = { label: userInput, current_project: currenProject, createdBy: userId, updatedBy: userId }
      const method = 'POST';
      HttpRequest.fetch(`scripts/admin_action_alerts/${path}/create`, { data, method })
        .then((res: any) => {
          if (res.id) {
            column.optionList.push({ id: res.id, label: userInput, createdBy: userId, updatedBy: userId, createdDate: '', updatedDate: '' });
            column.inputWarning = '';
            partialState[column.name] = column;
            partialState[inputName] = '';
            this.setState(partialState);
          }
        })
        .catch((res: Error) => {
          column.inputWarning = res.message;
          partialState[column.name] = column;
          this.setState(partialState);
        })
    });
  }


  isValidDomainName(domainName: string) {
    const domainRegexp = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/);
    return domainRegexp.test(domainName);
  }

  toggleModal(isOpen = !this.state.isPopUpAssigneeOpen) {
    this.setState({ isPopUpAssigneeOpen: isOpen });
  }

  countUsersOnDomain(domain: string) {
    const { users } = this.state;
    let activeUsers = users.filter((user) => user.email.includes(domain));
    return (activeUsers.length);
  }

  verifyUserPermissionsForBankWide(selectedUserID) {
    const { bankWideAvid } = this.state;

    verifyAvidAccess(selectedUserID, bankWideAvid.prevLink).then((hasAccess) => {
      if (hasAccess) {
        let prevUserID = (bankWideAvid.defaultAssignee ? bankWideAvid.defaultAssignee : undefined);
        if (!prevUserID) {
          this.updateDefaultUserBankwide(Number(selectedUserID), bankWideAvid, prevUserID);
        } else {
          this.setState({ userAssigmentConfirmationModalOpen: true, selectedUserIdInput: selectedUserID });
        }
      } else {
        this.setState({ userPermissionModalOpen: true })
      }
    })
  }

  renderTabs() {
    return (
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a className="nav-link active" href="#">User Assignment</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">Whitelist</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">Tracking</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">Severity Default</a>
        </li>
      </ul>
    );
  }

  renderHierarchyColumn(avid: Avid) {
    if (avid.childCount) {
      return (
        <a href='#' className="id-wrapper" onClick={() => {
          this.setState({ currentAvid: avid }, () => {
            this.getAvids(avid.nextLink);
            this.updateDrillDownPath({ avid: avid, label: avid.label }, -1);
          });
        }}>
          <i className="fas fa-search"></i>
          <span>&nbsp;{avid.label}</span>
        </a>
      );
    } else return (<span>&nbsp;{avid.label}</span>);
  }

  renderAssigneeColumn(avid: Avid) {
    let defaultAssignee = this.state.defaultUserID;
    if (avid.defaultAssignee) {
      defaultAssignee = avid.defaultAssignee;
    }
    let userIndex = this.state.users.findIndex((user) => user.id == defaultAssignee)
    if (userIndex < 0) {  // Fixed: was < 1, should be < 0 (index 0 is valid!)
      userIndex = this.state.users.findIndex((user) => user.id == this.state.bankWideAvid.defaultAssignee)
    }
    let userLabel = this.state.users[userIndex].username;
    return (
      <>
        <a href='#' className="id-wrapper" onClick={() => {
          this.setState({ selectedAvid: avid, isPopUpAssigneeOpen: true, selectedAvidDefaultUser: avid.defaultAssignee, inputCurrentAvidUser: avid.defaultAssignee });
        }}>
          <i className="fas fa-pencil-alt"></i>
        </a>
        <span>&nbsp;{userLabel}</span>
      </>
    );
  }

  renderHasGranularAssigment(childCount: number) {
    return (
      <>{(childCount ? 'YES' : 'NO')}</>
    );
  }

  renderMainContent() {
    const activeTab = this.state.activeTab;
    switch (activeTab) {
      case 'userAssignment':
        return this.renderUserAssignment();
      case 'whitelist':
        return this.renderWhitelist();
      case 'tracking':
        return this.renderTracking();
      case 'severity':
        return this.renderSeverityDefault();
      default:
        return (
          <p>No tab selected</p>
        );
    }
  }


  renderUserAssignment() {
    let { trail, childAvids, currentAvid, selectedAvid, userAssigmentConfirmationModalOpen, defaultUserIDBankwide, userPermissionModalOpen } = this.state;
    let selectedAvidUser = undefined;
    if (currentAvid.defaultAssignee) {
      selectedAvidUser = currentAvid.defaultAssignee;
    } else selectedAvidUser = (this.state.defaultUserID ? this.state.defaultUserID : undefined);

    let currentSelectedUser = (this.state.users.findIndex(u => u.id == currentAvid.defaultAssignee) > -1 ? this.state.users.find(u => u.id == currentAvid.defaultAssignee).username : '');
    let nextSelectedUser = (this.state.users.findIndex(u => u.id == this.state.selectedUserIdInput) > -1 ? this.state.users.find(u => u.id == this.state.selectedUserIdInput).username : '');
    return (
      <>
        <div className="col-md-5">
          <Collapse isOpen={!selectedAvidUser}>
            <div className="alert alert-primary" role="alert">
              <p className='text-body'>In order for Action Alerts to function on your platform, you must first select a default user to assign Action Alerts to. Once the default user is set, you will be able to go to your Action Alerts Dashboard <a href="#" className="alert-link">here</a>.</p>
            </div>
          </Collapse>
          <Collapse isOpen={selectedAvidUser > 0}>
            <div className="margin-bottom">
              <p className="font-weight-bolder">Organization-wide Default User:</p>
            </div>
          </Collapse>
          <div className='margin-bottom'>
            <UserSearchSelect
              required
              selectedUserID={this.state.bankWideAvid.defaultAssignee}
              label='Default User'
              onChange={(selectedUserID) => { this.verifyUserPermissionsForBankWide(selectedUserID) }}
              isSaving={this.state.isSavingAssignee}
            />
          </div>
          <p className="font-weight-bolder">When the Organization-wide Default User is changed that user will be search and replaced throughout the hierarchy</p>
        </div>
        <div className="col-md-7">
          {this.renderGranularAssigment(trail, childAvids, currentAvid)}
        </div>
        <Modal
          wrapClassName="blacklight"
          modalClassName="blacklight-modal"
          isOpen={userAssigmentConfirmationModalOpen}
        >
          <ModalHeader className='center' style={{ width: '100%' }}>
            Select a new Default User:
          </ModalHeader>
          <ModalBody>
            All notifications that previously went to ({currentSelectedUser}) will now go to {nextSelectedUser}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => { this.setState({ userAssigmentConfirmationModalOpen: false }) }}>Cancel</Button>
            <Button color="primary" onClick={() => {
              const { currentAvid } = this.state;
              let prevUserID = (currentAvid.defaultAssignee ? currentAvid.defaultAssignee : undefined);
              this.updateDefaultUserBankwide(Number(this.state.selectedUserIdInput), currentAvid, prevUserID);
              this.setState({ userAssigmentConfirmationModalOpen: false });
            }
            }>Update</Button>
          </ModalFooter>
        </Modal>
        <Modal
          wrapClassName="blacklight"
          modalClassName="blacklight-modal"
          isOpen={userPermissionModalOpen}
        >
          <ModalBody>
            <p>The user you have selected as the Organization Wide Default User does not have access to every part of
              the hierarchy.</p>
            <p>Please edit user's access or select a different user</p>
          </ModalBody>
          <ModalFooter>
            <Button color="warning" onClick={() => { this.setState({ userPermissionModalOpen: false }) }}>Close</Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }

  renderGranularAssigment(trail: trailNode[], childAvids: Avid[], currentAvid: Avid) {
    if ((currentAvid.hierarchyLevel == 'Bankwide' && currentAvid.defaultAssignee != undefined) || currentAvid.hierarchyLevel != 'Bankwide') {
      return (
        <>
          <header className='d-flex'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                {trail.map((node, idx) => {
                  return (<li className="breadcrumb-item" aria-current="page" key={idx} onClick={() => { this.updateCurrentAvid(node) }}>{node.label}</li>);
                })}
              </ol>
            </nav>
          </header>
          <DataGrid<Avid>
            records={childAvids}
            columns={[
              { header: 'Hierarchy', sortable: false, render: (avid) => this.renderHierarchyColumn(avid) },
              { header: 'Default Assignee', sortable: false, render: (avid) => this.renderAssigneeColumn(avid) },
            ]}
          />
          <Modal
            id='popUpAssignee'
            wrapClassName="blacklight"
            modalClassName="blacklight-modal"
            isOpen={this.state.isPopUpAssigneeOpen}
          >
            <ModalHeader>
              {this.state.selectedAvid.label}: Default Assignee
            </ModalHeader>
            <ModalBody>
              <div className="alert alert-warning" role="alert">
                By updating the default assignee for {this.state.selectedAvid.label}, all lower level assignments for (current user) will be changed to (new user).
              </div>
              <UserSearchSelect
                required
                selectedUserID={this.state.inputSelectedAvidUser}
                label='Default User'
                onChange={(selectedUserID) => this.setState({ inputSelectedAvidUser: Number(selectedUserID) })}
              />
              <br />
              <div style={{ marginTop: '1.5rem' }}>
                <button type="button" className="btn btn-light" onClick={() => { this.setState({ isPopUpAssigneeOpen: false, inputSelectedAvidUser: undefined }) }}>Cancel</button><button type="button" className="btn btn-primary" onClick={() => { this.saveAssignee(this.state.inputSelectedAvidUser, currentAvid.defaultAssignee, this.state.selectedAvid) }}>Update</button>
              </div>
            </ModalBody>
          </Modal>
        </>
      );
    }
  }

  renderWhitelist() {
    const domains = this.state.domains;
    return (
      <>
        <div className="col-md-6">
          <div className="alert alert-primary" role="alert">
            <p className='text-body'>In order to maintain privacy and security, restrict new users to those who have email addresses at the domains listed below. (Applies only to new users added through the Action Alerts user assignments)</p>
          </div>
          <ul className="list-group list-group-flush">
            <h5>Domains Whitelist</h5>
            {
              domains.map((domain, idx) => {
                return (
                  <li className="list-group-item d-flex justify-content-between align-items-center" key={idx}>
                    {domain.domain}
                    <i className="fas fa-trash" onClick={() => {
                      this.setState({
                        selectedDomain: domain,
                        isPopUpDeleteDomainOpen: true
                      });
                    }}></i>
                  </li>
                );
              })
            }
          </ul>
          <div className="input-group mb-3">
            <input id="inputDomain" name="inputDomain" type="text" className={(this.state.inputDomainValidation ? "form-control" : "form-control is-invalid")} placeholder="New Domain" value={this.state.inputDomain} aria-label="New Domain" aria-describedby="basic-addon2" onChange={this.handleInputChange} />
            <div className="input-group-append">
              <button type="button" className="btn btn-primary" onClick={() => this.addDomain()}><i className="fas fa-plus-circle"></i> Add</button>
            </div>
            {!this.state.inputDomainValidation &&
              <div className="invalid-feedback">
                {this.state.inputDomainWarningText}
              </div>
            }
          </div>
        </div>
        <Modal
          id='popUpDeleteDomain'
          wrapClassName="blacklight"
          modalClassName="blacklight-modal"
          isOpen={this.state.isPopUpDeleteDomainOpen}
        // toggle={() => this.toggleModal()}
        >
          <ModalHeader>
            Delete Domain from Whitelist
          </ModalHeader>
          <ModalBody>
            <p>You are about to delete the domain "{(this.state.selectedDomain ? this.state.selectedDomain.domain : '')}". There are {this.countUsersOnDomain((this.state.selectedDomain ? this.state.selectedDomain.domain : ''))} users with this domain on your platform. once this domain is deleted, the users will no longer have access to the platform.</p>
            <br />
            <div style={{ marginTop: '1.5rem' }}>
              <button type="button" className="btn btn-light" onClick={() => { this.setState({ isPopUpDeleteDomainOpen: false }) }}>Cancel</button><button type="button" className="btn btn-destructive" onClick={() => { this.deleteDomain(this.state.selectedDomain.id) }}>Delete</button>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }

  renderTracking() {
    const { rootCauseColumn, endStateColumn } = this.state;
    return (
      <>
        <div className="col-sm-6 col-md-3">
          {this.renderTrackingColumn(rootCauseColumn, 'Root Cause', 'inputRootCause')}
        </div>
        <div className="col-sm-6 col-md-3">
          {this.renderTrackingColumn(endStateColumn, 'End State', 'inputEndState')}
        </div>
        {this.renderDeleteOptionModal(endStateColumn, 'Delete End State', 'You are about to delete the End State Option “' + endStateColumn.selectedItemLabel + '”. Action Alerts already using this option will require a replacement.')}
        {this.renderDeleteOptionModal(rootCauseColumn, 'Delete Root Cause', 'You are about to delete the Root Cause Option “' + rootCauseColumn.selectedItemLabel + '”. Action Alerts already using this option will require a replacement.')}
      </>
    );
  }

  renderTrackingColumn(column: TrackingColumn, title: string, inputName: string) {
    return (
      <section>
        <h4 className='column-title'>{title}</h4>
        <div className="d-flex justify-content-between p-1 text-dark">
          <span>Enable</span><i className={(column.isEnable ? "fas fa-check-square fa-lg text-black-50" : "far fa-square fa-lg text-black-50")} onClick={() => this.updateCheckboxField(column, 'isEnable', true)}></i>
        </div>
        <div className={(column.optionList.length > 0 && column.isEnable ? "d-flex justify-content-between p-1 text-dark" : "d-flex justify-content-between p-1 text-muted")}>
          <span>Required</span><i className={(column.isRequired ? "fas fa-check-square fa-lg text-black-50" : "far fa-square fa-lg text-black-50")} onClick={() => this.updateCheckboxField(column, 'isRequired', column.optionList.length > 0 && column.isEnable)}></i>
        </div>
        <h4 className='column-title'>{title} Options</h4>
        {this.renderOptionList(column, title)}
        <div className="input-group mb-3">
          <input id={inputName} name={inputName} type="text" className="form-control" placeholder="New Option" value={this.state[inputName]} aria-label="New Option" aria-describedby="basic-addon2" disabled={!column.isEnable} onChange={(e) => { if (column.isEnable) this.handleInputChange(e) }} />
          <div className="input-group-append">
            <button type="button" className="btn btn-primary" onClick={() => this.addOption(column)} disabled={!column.isEnable}><i className="fas fa-plus-circle"></i> Add</button>
          </div>
        </div>
        {column.inputWarning.length > 0 &&
          <p className="text-danger">{column.inputWarning}</p>
        }
      </section>
    );
  }

  renderOptionList(column: TrackingColumn, title: string) {
    let list = column.optionList;
    let partialState = {}
    if (list.length > 0) {
      {
        return (
          list.map((item, idx) => {
            return (
              <div className={column.isEnable ? "d-flex justify-content-between p-1 text-dark" : "d-flex justify-content-between p-1 text-muted"} key={idx}>
                <span>{item.label}</span><i className="fas fa-trash fa-lg text-black-50" onClick={() => {
                  if (column.isEnable) {
                    column.isPopUpOpen = true;
                    column.selectedItemID = item.id;
                    column.selectedItemLabel = item.label;
                    partialState[column.name] = column;
                    this.setState(partialState);
                  }
                }}></i>
              </div>
            );
          })
        );
      }
    } else {
      return (
        <div className="alert alert-warning" role="alert">
          <i className="fas fa-sticky-note"></i>&nbsp;No options found for {title}
        </div>
      );
    }
  }

  renderDeleteOptionModal(column: TrackingColumn, title: string, warningText: string) {
    let partialState = {}
    if (column.isPopUpOpen) {
      return (
        <Modal
          id='popUpAssignee'
          wrapClassName="blacklight"
          modalClassName="blacklight-modal"
          isOpen={column.isPopUpOpen}
        >
          <ModalHeader>
            {title}
          </ModalHeader>
          <ModalBody>
            <div className="alert alert-warning" role="alert">
              {warningText}
            </div>
            <div className="form-group only-edit">
              <label htmlFor="inputRootCauseSelect" className="">Replacement for {title}</label>
              <select name="inputRootCauseSelect" className='custom-select' onChange={this.handleInputChange}>
                {column.optionList.map((option, idx) => {
                  if (option.id != column.selectedItemID) {
                    return (
                      <option value={option.id.toString()} key={'user' + idx}>{option.label}</option>
                    );
                  }
                })}
              </select>
              <div className="invalid-feedback">
                Please select a reason.
              </div>
            </div>
            <br />
            <div style={{ marginTop: '1.5rem' }}>
              <button type="button" className="btn btn-light" onClick={() => {
                column.isPopUpOpen = false;
                column.selectedItemID = undefined;
                column.selectedItemLabel = '';
                partialState[column.name] = column;
                this.setState(partialState);
              }}>
                Cancel
              </button>
              <button type="button" className="btn btn-destructive" onClick={() => { this.deleteOption(column) }}>Delete</button>
            </div>
          </ModalBody>
        </Modal>
      );
    } else {

    }
  }
  render() {
    return (
      <>
        <ul className="nav nav-tabs">
          {
            this.state.tabs.map((tab, idx) => {
              return (
                <li className="nav-item" key={idx}>
                  <a className={"nav-link" + (tab.isActive ? ' active' : '')} onClick={() => this.updateTabs(tab.value)}>{tab.label}</a>
                </li>
              );
            })
          }
        </ul>
        <main className="row">
          {this.renderMainContent()}
        </main>
      </>
    );
  }

  //severity default logic//
  componentDidMount() {
    this.getSeverityDefault()
  };

  // this to get all severity default for client
  getSeverityDefault() {
    HttpRequest.fetch('scripts/admin_action_alerts/get_severity_default')
      .then((res: any) => {
        if (res) {
          this.setState({ severityDefault: res });
        }
      })
  }

  //this is to update any changes made to the severity defaults
  severityChangeHandler = (e, index, id) => {
    const userId = userData.getUserDataFromSession('token').userId;
    this.state.severityDefault[index].severity_id = parseInt(e.target.value)
    this.setState(
      this.state
    )
    this.state.severityDefault[index].last_updated_by = parseInt(userId)
    this.setState(
      this.state
    )
    const severity_id = parseInt(e.target.value);
    const last_updated_by = userData.getUserDataFromSession('token').userId;
    const reason_id = parseInt(id);
    // const client = userData.getUserDataFromSession('client');

    $.ajax({
      url: 'scripts/admin_action_alerts/update_severity_default',
      type: 'POST',
      data: {
        'severity_id': severity_id,
        'last_updated_by': last_updated_by,
        'reason_id': reason_id
      },
      success: function () {
        console.log('sucess')
      }
    });
  }

  //this is to update any changes made to the severity defaults if uncomment button to update all at once
  // updateSeverityDefault() {
  //   const data = this.state.severityDefault;
  //   $.ajax({
  //     type: 'POST',
  //     url: 'scripts/admin_action_alerts/update_severity_default',
  //     data: {json: data},
  //     dataType: 'json'
  // });

  // }

  ///////////////////////

  renderSeverityDefault() {

    return (
      <>
        <div className='alertSeverityContainer'>
          <Form className='alertSeverityForm'>
            <div className='alertSeverityDiv'>
              <Col className='alertSeverityCol'>
                {this.state.severityDefault.map((reason, index) => (
                  <div className='alertSeverityBox' style={{ margin: 10 }}>
                    <div className='alertSeverityHeader'>
                      {reason.reason}
                    </div>
                    <Row check className='alertSeverityRow'>
                      <div className='alertSeverityLabel'>
                        <Input
                          className='alertSeverityInput'
                          type="radio"
                          name={reason.reason}
                          value="1"
                          checked={reason.severity_id === 1}
                          onChange={e => this.severityChangeHandler(e, index, reason.reason_id)}
                        />{' '}
                        <span className='span'>Low</span>
                      </div>
                      <div className='alertSeverityLabel'>
                        <Input
                          className='alertSeverityInput'
                          type="radio"
                          name={reason.reason}
                          value="2"
                          checked={reason.severity_id === 2}
                          onChange={e => this.severityChangeHandler(e, index, reason.reason_id)}
                        />{' '}
                        <span className='span'> Moderate </span>
                      </div>
                      <div className='alertSeverityLabel'>
                        <Input
                          className='alertSeverityInput'
                          type="radio"
                          name={reason.reason}
                          value="3"
                          checked={reason.severity_id === 3}
                          onChange={e => this.severityChangeHandler(e, index, reason.reason_id)}
                        />{' '}
                        <span className='span'>High</span>
                      </div>
                      <div className='alertSeverityLabel'>
                        <Input
                          className='alertSeverityInput'
                          type="radio"
                          name={reason.reason}
                          value="4"
                          checked={reason.severity_id === 4}
                          onChange={e => this.severityChangeHandler(e, index, reason.reason_id)}
                        />{' '}
                        <span className='span'>Critical</span>
                      </div>
                    </Row>
                  </div>
                ))}
              </Col>
            </div>
            {/* <Col className='alertSeverityCol'>
              <Button onClick={() => {this.updateSeverityDefault()}}>
                Submit
              </Button>
            </Col> */}
          </Form>
        </div>
      </>
    );
  }

}
